import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Sun, Moon } from "lucide-react";
import { useLanguage, LANGUAGES, getTranslation } from "../utils/language";
import { ThemeContext } from "../context/ThemeContext";
import "../style/navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [language, changeLanguage] = useLanguage();
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [openLang, setOpenLang] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = LANGUAGES.find((l) => l.code === language) || LANGUAGES[2]; // fallback to EN

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenLang(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="site-navbar">
      <div className="navbar-content" onClick={() => navigate("/")}>
        <img 
          src="/apple-touch-icon.png" 
          alt="Logo" 
          className="navbar-logo"
        />
        <div className="navbar-brand">
          <span className="brand-main">{getTranslation(language, "navbar", "brandMain")}</span>
          <span className="brand-sub">{getTranslation(language, "navbar", "brandSub")}</span>
        </div>
      </div>

      <div className="navbar-right" ref={dropdownRef}>
        <button
          type="button"
          className="navbar-theme-btn"
          onClick={toggleTheme}
          title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
        </button>

        <button
          type="button"
          className="navbar-lang-btn"
          onClick={() => setOpenLang((o) => !o)}
          title="Choose Language"
        >
          <span className="lang-globe">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
              <path d="M2 12h20" />
            </svg>
          </span>
          <span className="lang-label">{currentLang.label}</span>
          <span className="lang-caret">▾</span>
        </button>

        {openLang && (
          <div className="navbar-lang-menu">
            <div className="navbar-lang-menu-title">Choose Language / भाषा निवडा</div>
            <div className="navbar-lang-menu-items">
              {LANGUAGES.map((lang) => (
                <button
                  key={lang.code}
                  type="button"
                  className={`navbar-lang-option ${language === lang.code ? "active" : ""}`}
                  onClick={() => {
                    changeLanguage(lang.code);
                    setOpenLang(false);
                  }}
                >
                  <span className="lang-code-badge">{lang.code.toUpperCase()}</span>
                  <span className="lang-name">{lang.label}</span>
                  {language === lang.code && <span className="lang-check">✓</span>}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
